import {
  Action,
  config,
  Module,
  VuexModule,
} from 'vuex-module-decorators';
import { getApiConfiguration } from '@/helpers/api';
import store from '@/store/index';
import {
  AddressApi,
  InputAdresss,
} from '@/services/generated/client';

config.rawError = true;

// API
let addressApi: AddressApi | null = null;
const getAddressApi = (): AddressApi | null => {
  if (!addressApi) addressApi = new AddressApi(getApiConfiguration());

  return addressApi;
};

@Module({
  name: 'address',
  namespaced: true,
  dynamic: true,
  store,
})
export default class AddressStore extends VuexModule {
  @Action
  getSuggestedAddresses(inputAddress: InputAdresss) {
    return getAddressApi().suggestSmartformAddress({ inputAdresss: inputAddress });
  }
}
